import { Theme, useMediaQuery, useTheme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Tooltip from "@material-ui/core/Tooltip"
import CloseIcon from "@material-ui/icons/Close"
import { get } from "browser-cookies"
import React, { Fragment, useContext } from "react"
import { AppContext } from "Views/Home/context"
import cal from "clsx"
import { CalendarContext } from "./context"
import { Board, BoardAction, BoardModifyDialog } from "Types/board"
import { useMouseGesture } from "Hooks/basic"
import { useDeleteBoard } from "Hooks/board"
import { InitialModal } from "Methods/modal"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        color: "white",
        backgroundColor: "#999",
        position: "absolute",
        // width: "80%",
        borderRadius: 6,
        width: "90%",
        height: 40,
        right: 4,
        top: 4,
        zIndex: 1,
        padding: "0 20px 0 10px",
        cursor: "pointer",
        transition: "all .3s ease",
        // height: 20,
        wordBreak: "break-word",
        userSelect: "none",
        // "&:hover": {
        //     width: "90%",
        //     height: 40,
        //     transition: "all .3s ease",
        // },
        overflowY: "scroll",
    },
    move: {
        width: "90%",
        height: 40,
        transition: "all .3s ease",
        cursor: "move",
        border: "2px dashed #ddd",
        opacity: 0.6,
    },
    pass: {
        opacity: "0.6",
    },
    mine: {
        paddingRight: "10px",
    },
    icon: {
        fontWeight: "bold",
        position: "absolute",
        right: 1,
        top: 0,
        opacity: 0,
    },
    iconShow: {
        opacity: 1,
    },
    redDot: {
        position: "absolute",
        width: 10,
        height: 10,
        left: 0,
        borderRadius: "100%",
        backgroundColor: "red",
    },
}))

const updateTypes: { [any: string]: BoardAction } = {
    '微博': 'weibo_update',
    '微信': 'wechat_update',
    '童学馆': 'child_update',
    '果壳视频': 'video_update',
    '摄影': 'photo_update',
    '美丽': 'beauty_update',
    '果壳自然': 'species_update',
    '吃货': 'eat_update',
    '果壳病人': 'health_update',
}

interface ComponentProps {
    board: Board,
    date: Date,
}
let pressTimer: number
const pressTimeout = 200
const BoardItem = (props: ComponentProps) => {
    const userUid: string = get("uid") || ""
    const { board, date } = props
    const classes = useStyles()
    const { creator_info, creator_id, author, principal_id, material, principal_user } = board
    const { department, nickname } = creator_info || {}
    const {
        handleChangeBoardModifyDialog, boardModifyDialog,
        isWeChat, isWeibo, privilege, movableBoard, handleSetMovableBoard, channelName
    } = useContext(CalendarContext)

    const generateColor = ({ article_type, child_article_type, photo_article_type, beauty_article_type, species_article_type, eat_article_type }: Board) => {
        if (channelName === '美丽') return beauty_article_type
        if (channelName === '童学馆') return child_article_type
        if (channelName === '摄影') return photo_article_type
        if (channelName === '果壳自然') return article_type
        if (channelName === '吃货') return eat_article_type
        return article_type
    }

    const { color_code = "" } = generateColor(board) || {}
    const { color, name } = department || {}
    const { user, roleMap } = useContext(AppContext)
    const { role, department: { type_name = '' } = {}, } = user || {}
    const { role_name = '' } = role || {}
    const { isBusiness } = roleMap
    const isSideEditor = role_name === "side_editor"
    const isTrueEditor = role_name === "true_editor"
    const isOpEditor = role_name === "op_editor"
    const isUser = role_name === "user"
    const isPhotoer = role_name === "photoer"
    const isMarketingUser = type_name === 'marketing' && role_name === 'user'
    const isCreateByMarketing = creator_info.department.type_name === 'marketing'
    const { uid } = author || {}
    const { show, handleMouseEnter, handleMouseLeave } = useMouseGesture()
    const { handleChangeModal } = useContext(AppContext)
    const { del } = useDeleteBoard(channelName)
    const isMine = userUid === creator_id
    const isPrincipal = userUid === principal_id
    const isAuthor = userUid === uid
    const isPass = new Date().getTime() - (24 * 3600 * 1000) > date.getTime()
    // 编辑部主编和编辑部运营可查看和编辑过期预约内容
    // 商务部可编辑自己的过期预约部分字段：http://taiga.iguokr.com/project/liyang-noah/us/2517
    // const isPassDisabled = isPass && !isTrueEditor && !isOpEditor && !(isBusiness && isMine)
    // const isOneDay = date.getTime() - new Date().getTime() <  0
    const isThreeDay = date.getTime() - new Date().getTime() < 2 * 24 * 3600 * 1000
    const isTwoDay = date.getTime() - new Date().getTime() < 1 * 24 * 3600 * 1000

    const handleEditBoard = (event: React.MouseEvent) => {
        event.stopPropagation()
        if (channelName === '美丽') return beautyEdit()
        if (channelName === '童学馆') return childrenEdit()
        if (channelName === '果壳视频') return videoEdit()
        if (channelName === '摄影') return photoEdit()
        if (channelName === '果壳自然') return speciesEdit()
        if (channelName === '吃货') return eatEdit()
        if (channelName === '果壳病人') return healthEdit()

        const isBoardPrincipalMarketing = principal_user ? principal_user.department.type_name === 'marketing' : false

        // 可以出现编辑弹窗
        let canShowEditModal = false
        if (isPass) {
            // 编辑部主编/编辑部运营可查看和编辑过期预约内容
            if (isTrueEditor || isOpEditor) canShowEditModal = true
            // 商务部可编辑自己的过期预约部分字段：http://taiga.iguokr.com/project/liyang-noah/us/2517
            else if (isBusiness && !['pc站点', '移动站点', '果壳APP'].includes(channelName) && isMine) canShowEditModal = true
        } else {
            // 双微日历，一些身份不可编辑三天内的预约
            if (!isWeibo && !isWeChat) canShowEditModal = true
            else if (!isThreeDay) canShowEditModal = true
            // 点位运营不可编辑
            // 商务部可编辑部分字段：http://taiga.iguokr.com/project/liyang-noah/us/2517
            else if (isBusiness || !isUser) canShowEditModal = true
        }

        if (!canShowEditModal) return

        // 预约日历（即非双微，点位运营
        // 商务部可编辑自己的过期预约部分字段：http://taiga.iguokr.com/project/liyang-noah/us/2517
        // if (isPassDisabled || ((isWeibo || isWeChat) && isThreeDay && (isUser && !isBusiness))) {
        //     return
        // }

        // 营销部的点位运营可以编辑负责人属于营销部的全部预约，包括编辑内容和物料。
        if (privilege.update || isMine || isAuthor || isPrincipal || (isMarketingUser && (isCreateByMarketing || isBoardPrincipalMarketing) && isWeChat)) {
            const type: BoardAction = updateTypes[channelName] || "update"
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                isPass,
                isThreeDay,
                show: true,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const childrenEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 商务部可编辑自己的预约
        const isBusinessAndMine = type_name === 'business' && isMine
        if (
            isBusinessAndMine
            || (isMine && !isPass || ['children'].indexOf(type_name) >= 0 && ['side_editor'].indexOf(role_name) >= 0)
            // 电商内容 编辑部编辑 日历所有人预约的增删改查
            || (isSideEditor && type_name === 'newmedia')
        ) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const speciesEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 权限：http://taiga.iguokr.com/project/liyang-noah/us/2410
        // 已结束则不能操作
        const isBusinessAndMine = type_name === 'business' && isMine
        if (isPass && !isBusinessAndMine) return
        // 编辑部主编可修改所有点位
        const isMainEditorOfEditorPartment = type_name === 'editor' && role_name === 'true_editor'
        // 编辑部运营可以修改物种日历
        const isOpEditor = role_name === 'op_editor'
        // 所有部门编辑、点位运营可对自己的进行操作
        const isEditorOrUserOfAllPartment = ['side_editor', 'user'].includes(role_name)

        // 商务部可编辑自己的预约

        // 营销部的点位运营可以编辑负责人属于营销部的全部预约，包括编辑内容和物料。

        if (isBusinessAndMine || isMainEditorOfEditorPartment || isOpEditor || (isMine && isEditorOrUserOfAllPartment) || (isMarketingUser && isCreateByMarketing)) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const healthEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 权限：http://taiga.iguokr.com/project/liyang-noah/us/2410
        // 已结束则不能操作
        const isBusinessAndMine = type_name === 'business' && isMine
        if (isPass && !isBusinessAndMine) return
        // 编辑部主编可修改所有点位
        const isMainEditorOfEditorPartment = type_name === 'editor' && role_name === 'true_editor'
        // 编辑部运营可以修改物种日历
        const isOpEditor = role_name === 'op_editor'
        // 所有部门编辑、点位运营可对自己的进行操作
        const isEditorOrUserOfAllPartment = ['side_editor', 'user'].includes(role_name)

        // 商务部可编辑自己的预约

        // 营销部的点位运营可以编辑负责人属于营销部的全部预约，包括编辑内容和物料。

        if (isBusinessAndMine || isMainEditorOfEditorPartment || isOpEditor || isSideEditor || (isMine && isEditorOrUserOfAllPartment) || (isMarketingUser && isCreateByMarketing)) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const eatEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 权限：https://taiga.iguokr.com/project/yan-fa-shi-yan-shi/us/1224?milestone=627
        // 已结束则不能操作
        // const isBusinessAndMine = type_name === 'business' && isMine
        if (isPass) return
        // 电商内容-编辑部编辑：查看，添加和编辑删除
        const isMainEditorOfEatPartment = type_name === 'newmedia' && role_name === 'side_editor'
        // 商务部\营销部\视频部-点位运营可对自己的进行操作
        const isUserOfEatPartment = ['business', 'video', 'marketing'].includes(type_name) && role_name === 'user'

        if (isMainEditorOfEatPartment || (isMine && isUserOfEatPartment)) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }

    const videoEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id
        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 商务部可编辑自己的预约
        const isBusinessAndMine = type_name === 'business' && isMine
        if (isBusinessAndMine || (isMine && !isPass)) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }

    const photoEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user

        // 商务部可编辑自己的预约
        const isBusinessAndMine = type_name === 'business' && isMine
        if (isBusinessAndMine || (isMine && !isPass || ['photo'].indexOf(type_name) >= 0 && ['photoer'].indexOf(role_name) >= 0)
        ) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const beautyEdit = () => {
        const userUid: string = get("uid") || ""
        const { creator_id } = board

        const isMine = userUid === creator_id

        const {
            department: { type_name = '' } = {},
            role: { role_name = '' } = {}
        } = user
        // 商务部可编辑自己的预约
        const isBusinessAndMine = type_name === 'business' && isMine
        // 营销部点位运营可编辑所有人点位
        if (
            isMarketingUser
            || isBusinessAndMine
            || ((isSideEditor || (isMine && isUser)) && !isPass && ['beauty', 'marketing'].indexOf(type_name) >= 0)
            // 电商内容 编辑部编辑 日历所有人预约的增删改查
            || (isSideEditor && type_name === 'newmedia')
        ) {
            const type: BoardAction = updateTypes[channelName]
            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                isPass,
                board_id: board.id,
                board,
                date,
                type,
            })
        }
    }
    const handleDelBoard = async (event: React.MouseEvent) => {
        event.stopPropagation()
        // 编辑部主编可删除过期预约内容
        if (isPass && !isTrueEditor) {
            return
        }
        handleChangeModal({
            show: true,
            type: "warning",
            title: `确定删除预约 ${board.name || board.description}？`,
            showCancel: true,
            onConfirm: async () => {
                try {
                    await del({
                        variables: {
                            id: board.id,
                        },
                    })
                    handleChangeModal({
                        show: true,
                        type: "success",
                        title: "已删除！",
                        timeout: 800,
                        customButtons: [],
                        onConfirm: () => {
                            handleChangeModal(InitialModal)
                        },
                    })
                } catch (e) {
                    if (!navigator.onLine) {
                        handleChangeModal({
                            show: true,
                            type: "warning",
                            customButtons: [],
                            title: "oops! 断网啦！",
                            timeout: 3000,
                            onConfirm: () => {
                                handleChangeModal(InitialModal)
                            },
                        })
                        return
                    }
                }
            },
            onCancel: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    const handleStartMove = (event: React.MouseEvent) => {
        event.stopPropagation()
        // 编辑部主编可移动过期预约内容
        if ((!(isPass && !isTrueEditor) && privilege.update && (isWeibo || (isWeChat && board.author_id))) || (channelName === '果壳自然' && isTrueEditor) || (channelName === '吃货' && isSideEditor) || (channelName === '果壳病人' && (isTrueEditor || isSideEditor))) {
            pressTimer = window.setTimeout(() => {
                handleSetMovableBoard(board)
            }, pressTimeout)
        }
    }
    const isMoving = movableBoard !== null && movableBoard.id
    const isMove = board.id === (movableBoard && movableBoard.id)
    const handleEndMove = () => {
        window.clearTimeout(pressTimer)
        handleSetMovableBoard(null)
        if (!isMove && isMoving) {
            handleChangeModal({
                show: true,
                type: "error",
                customButtons: [],
                title: "已有内容，不可替换",
                timeout: 800,
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        }
    }
    let showText = board.name
    if (isWeChat) {
        showText = `${board.author ? `【${board.author.name}】` : ""}${board.description}`
    }
    // 点位运营不可删除三天内的双微
    const userEnableDel: boolean = (isWeibo || isWeChat) && isThreeDay && isUser
    // 编辑部编辑不可删除日历条目
    const showDeleteIcon = !isSideEditor && (privilege.delete || isMine || isPrincipal)
    const showRedDot = material && (material.status === "unfilled" || material.status === "unfinished")

    const childDelIcon = channelName === '童学馆'
        && !(isPass && !isTrueEditor)  // handleDelBoard 限制条件
        && ((
            // wtf
            (['children', 'marketing', 'business', 'video'].indexOf(type_name) >= 0
            && ['user', 'side_editor'].indexOf(role_name) >= 0
            && isMine)
            // && !isThreeDay)
            ||
            (['children'].indexOf(type_name) >= 0
            && ['side_editor'].indexOf(role_name) >= 0)
        )
        // 电商内容 编辑部编辑 日历所有人预约的增删改查
        || (type_name === 'newmedia' && role_name === 'side_editor')
        ) ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null
    const videoDelIcon = channelName === '果壳视频' && isMine && !isPass ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null
    const photoDelIcon = channelName === '摄影'
        && !(isPass && !isTrueEditor)  // handleDelBoard 限制条件
        && (
            ['user'].indexOf(role_name) >= 0
            && isMine
            && !isTwoDay
            ||
            ['photo'].indexOf(type_name) >= 0
            && ['photoer'].indexOf(role_name) >= 0
        ) ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null
    // 营销部点位运营可删除所有
    const BeautyDelIcon =
    (
    channelName === '美丽'
    && (isMarketingUser || isSideEditor || (isMine && isUser))
    && !isPass
    )
    ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null

    // 物种：http://taiga.iguokr.com/project/liyang-noah/us/2410
    // 编辑部主编可删除所有点位
    const isMainEditorOfEditorPartment = isTrueEditor && type_name === 'editor'
    // 其他编辑、点位运营可删除自己的
    const isEditorOrUserOfAllPartment = ['user', 'side_editor'].includes(role_name)

    const SpeciesDelIcon = channelName === '果壳自然' && !isPass && (isMainEditorOfEditorPartment || (isMine && isEditorOrUserOfAllPartment)) ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null

    // 病人
    const HealthDelIcon = channelName === '果壳病人' && !isPass && (isMainEditorOfEditorPartment || (isMine && isEditorOrUserOfAllPartment) || isSideEditor) ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null

    // 吃货：https://taiga.iguokr.com/project/yan-fa-shi-yan-shi/us/1224?milestone=627
    // 电商内容-编辑部编辑可删除所有节点
    const isEditorOfEatPartment = type_name === 'newmedia' && role_name === 'side_editor'
    // 商务部\营销部\视频部-点位运营 删除仅能删除三天后的预约，删除/编辑仅限自己的那条
    const isUserOfEatPartment = ['business', 'video', 'marketing'].includes(type_name) && role_name === 'user'
    const EatDelIcon = channelName === '吃货' && !isPass && (isEditorOfEatPartment || (isMine && isUserOfEatPartment && !isThreeDay)) ? (
        <CloseIcon
            fontSize="small"
            className={cal(
                classes.icon,
                show && classes.iconShow,
            )}
            onClick={handleDelBoard}
        />
    ) : null

    const theme = useTheme()
    const wideScreen = useMediaQuery(theme.breakpoints.up('md'))

    return (
        <Fragment>
            <Tooltip
                title={`${name} ${nickname}预约`}
                placement="top"
            >
                <div
                    className={cal(
                        classes.root,
                        !isMine && classes.mine,
                        isMove && classes.move,
                        isPass && classes.pass,
                    )}
                    style={{ background: color_code || color }}
                    onPointerEnter={handleMouseEnter}
                    onPointerLeave={handleMouseLeave}
                    onClick={handleEditBoard}
                    onPointerDown={handleStartMove}
                    onPointerUp={handleEndMove}
                >
                    <div className={cal(
                        classes.redDot,
                    )} style={{ opacity: showRedDot ? 1 : 0 }} />
                    {showText}
                    {/* 童学馆单独展示 */}
                    {/* 果壳视频单独展示 */}
                    {/* 摄影单独展示 */}
                    {/* 编辑部主编可删除过期预约内容 */}
                    {
                    !['童学馆', '果壳视频', '摄影', '美丽', '果壳自然', '吃货', '果壳病人'].includes(channelName)
                    && (isTrueEditor || (show || !wideScreen) && showDeleteIcon && !isMove && !isPass && !userEnableDel)
                    && (
                        <CloseIcon
                            fontSize="small"
                            className={cal(
                                classes.icon,
                                (show || !wideScreen) && classes.iconShow,
                            )}
                            onClick={handleDelBoard}
                        />
                    )}
                    {childDelIcon}
                    {videoDelIcon}
                    {photoDelIcon}
                    {BeautyDelIcon}
                    {SpeciesDelIcon}
                    {EatDelIcon}
                    {HealthDelIcon}
                </div>
            </Tooltip>
        </Fragment>
    )
}

export default BoardItem
